import React, { useState, useEffect } from "react";
// Import API constants
import { SETTINGS_API } from "../api";
import "./OurLocation.css";

// --- START: STATIC FALLBACK DATA ---
const STATIC_SETTINGS_FALLBACK = {
  address: "117-C Zafar Ullah Rd, Satellite Town, Sargodha, 40100",
  phone: "0483252717", // Default phone number
  email: "sihs.edu.pk@gmail.com", 
  // A publicly working/safe map URL fallback
  mapEmbedUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3380.5148370935412!2d72.68144240000001!3d32.082368599999995!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x392177c78290fa5f%3A0x565020a87a5cbf2!2sSargodha%20Institute%20of%20Health%20Sciences!5e0!3m2!1sen!2s!4v1763187693751!5m2!1sen!2s",
  openingHours: {
    mondayFriday: "8:00 AM - 4:00 PM",
    saturday: "Closed",
    sunday: "Closed",
  },
};
// --- END: STATIC FALLBACK DATA ---


function OurLocation() {
  // Initialize settings with the static fallback data
  const [settings, setSettings] = useState(STATIC_SETTINGS_FALLBACK);

  useEffect(() => {
    // Attempt to fetch live data from the backend
    fetch(SETTINGS_API.SITE)
      .then((res) => {
        if (!res.ok) {
          // Throw an error if the HTTP status is not 200-299
          throw new Error("Network response was not ok.");
        }
        return res.json();
      })
      .then((data) => setSettings(data))
      .catch((err) => {
        console.error("Error fetching settings, using static fallback:", err);
        // If fetch fails, the initial state (STATIC_SETTINGS_FALLBACK) is kept.
      });
  }, []);

  return (
    <section className="our-location-section">
      <div className="container">
        <h2 className="section-title">Our Location</h2>

        <div className="contact-section-card">
          {/* Map Column */}
          <div className="col" style={{ flex: 1 }}>
            <div className="map-container-compact">
              <iframe
                // Use the mapEmbedUrl from the state (which is guaranteed to exist)
                src={settings?.mapEmbedUrl}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Sargodha Medical College Map"
              ></iframe>
            </div>
          </div>

          {/* Contact Info Column */}
          <div className="col" style={{ flex: 1 }}>
            <div className="contact-info-compact">
              <h3
                style={{
                  color: "#003366",
                  fontWeight: 600,
                  marginBottom: "20px",
                }}
              >
                Find Us
              </h3>

              <div className="contact-info-item">
                <i className="fas fa-map-marker-alt"></i>
                <div>
                  <strong>Address</strong>
                  <p>{settings?.address}</p>
                </div>
              </div>

              <div className="contact-info-item">
                <i className="fas fa-phone-alt"></i>
                <div>
                  <strong>Phone</strong>
                  <p>{settings?.phone}</p>
                </div>
              </div>

              <div className="contact-info-item">
                <i className="fas fa-envelope"></i>
                <div>
                  <strong>Email</strong>
                  <p>{settings?.email}</p>
                </div>
              </div>

              <h4
                style={{
                  color: "#003366",
                  marginTop: "20px",
                  marginBottom: "10px",
                }}
              >
                Opening Hours
              </h4>
              <ul className="opening-hours">
                <li>
                  <span>Monday - Friday:</span>{" "}
                  <span>
                    {settings?.openingHours?.mondayFriday}
                  </span>
                </li>
                <li>
                  <span>Saturday:</span>{" "}
                  <span>
                    {settings?.openingHours?.saturday}
                  </span>
                </li>
                <li>
                  <span>Sunday:</span>{" "}
                  <span>{settings?.openingHours?.sunday}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default OurLocation;